export default "https://platform-api.carrotenglish.net";
//export default "https://stage-platform-api.carrotenglish.net";
//export default "http://localhost:8888";
